import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {isHeadless} from '../../../../../../commons/selectors/environment'
import {useAppActions, useAppSelector} from '../../../hooks/runtime'
import {BackToSiteButton} from '../../common/back-to-site-button'
import {RegistrationButtonSkin} from '../../registration-buttons/registration-button-skin'
import {Container} from '../common/container'
import {Subtitle} from '../common/subtitle'
import {Title} from '../common/title'

export const OrderFailed = () => {
  const {t} = useTranslation()
  const {navigateToDetails} = useAppActions()

  const headless = useAppSelector(isHeadless)

  return (
    <Container dataHook="order-failed">
      <div style={{textAlign: 'center'}}>
        <Title text={t('paymentError.paymentCanceledTitle')} />
        <Subtitle lines={[t('paymentError.paymentCanceledDescription')]} />
        {headless ? (
          <BackToSiteButton text={t('paymentError.buttonText')} />
        ) : (
          <RegistrationButtonSkin text={t('paymentError.buttonText')} onClick={() => navigateToDetails()} />
        )}
      </div>
    </Container>
  )
}
